import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import { sendRcon } from "../../../http/ServerAPI";

export const VipModal = ({ open, onClose, player, serverId }) => {
    const [type, setType] = useState("vip");
    const [days, setDays] = useState(30);

    const handleSubmit = async () => {
        let command;
        if (type === 'vip') {
            command = days > 0 ? `addgroup ${player.steam_id} vip ${days}d` : `removegroup ${player.steam_id} vip`;
        } else if (type === 'fermer') {
            command = days > 0 ? `addgroup ${player.steam_id} fermer ${days}d` : `removegroup ${player.steam_id} fermer`;
        } else if (type === 'tool_unbreakable') {
            command = `grantperm ${player.steam_id} neverwear.tools ${days}d`;
        } else if (type === 'weapon_unbreakable') {
            command = `grantperm ${player.steam_id} neverwear.weapons ${days}d`;
        }

        if (command) {
            await sendRcon(serverId, command, 'command');
        }
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Выдать привилегию</DialogTitle>
            <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                <FormControl fullWidth size="small">
                    <InputLabel>Тип</InputLabel>
                    <Select value={type} label="Тип" onChange={e => setType(e.target.value)}>
                        <MenuItem value="vip">VIP</MenuItem>
                        <MenuItem value="fermer">Фермер</MenuItem>
                        <MenuItem value="tool_unbreakable">Неломайка инструмента</MenuItem>
                        <MenuItem value="weapon_unbreakable">Неломайка оружия</MenuItem>
                    </Select>
                </FormControl>
                <TextField label="На сколько дней" type="number" size="small" value={days} onChange={e => setDays(e.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Отмена</Button>
                <Button variant="contained" onClick={handleSubmit}>Выдать</Button>
            </DialogActions>
        </Dialog>
    );
};

export const BalanceModal = ({ open, onClose, player }) => {
    const [balance, setBalance] = useState("");
    const [bonuses, setBonuses] = useState("");

    const handleApply = () => {
        console.log("BALANCE", { steam_id: player.steam_id, balance, bonuses });
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Изменить баланс</DialogTitle>
            <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                <TextField label="Баланс" type="number" size="small" value={balance} onChange={e => setBalance(e.target.value)} />
                <TextField label="Бонусы" type="number" size="small" value={bonuses} onChange={e => setBonuses(e.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Отмена</Button>
                <Button variant="contained" onClick={handleApply}>Применить</Button>
            </DialogActions>
        </Dialog>
    );
};

export const ConfirmModal = ({ open, onClose, title, onConfirm, danger }) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogActions>
            <Button onClick={onClose}>Отмена</Button>
            <Button variant="contained" color={danger ? "error" : "primary"} onClick={onConfirm}>Подтвердить</Button>
        </DialogActions>
    </Dialog>
);
